import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	pageHeading: {
		id: 'fastshift-portal.cs-profiler.page-heading',
		defaultMessage: 'CS Profiler',
		description: 'Heading for the CS Profiler page in FastShift Portal',
	},
});
